import styled from "styled-components";
import { Box, Card, Typography } from "@mui/material";

const mainColor = "#146cfa";

export const CustomCard = styled(Card)`
  && {
    height: 243px;
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    position: relative;
    overflow: hidden;
  }

  &&:hover .hoverText {
    opacity: 1;
    visibility: visible;
  }
`;

export const CustomCardHeader = styled(Box)`
  && {
    background-color: ${mainColor};
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const CustomIcon = styled.img`
  && {
    max-width: 72px;
    max-height: 72px;
    object-fit: contain;
  }
`;

export const CustomCardTextContainer = styled(Box)`
  && {
    width: 100%;
    min-height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
  }
`;

export const CustomCardText = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;
    color: ${mainColor};
    font-family: Figtree, sans-serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    max-width: 160px;
  }
`;

export const CustomHoverText = styled(Box).attrs({
  className: "hoverText",
})`
  && {
    position: absolute;
    inset: 0;
    z-index: 2;

    display: flex;
    align-items: center;
    justify-content: center;

    padding: 24px;
    background-color: ${mainColor};

    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s ease, visibility 0.25s ease;
  }
`;

export const CustomHoverTextContent = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;
    color: #ffffff;
    font-family: Figtree, sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
  }
`;